import { Injectable } from '@angular/core';
import { from, Observable, Subject, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams, HttpHeaders} from '@angular/common/http';
import { catchError, tap} from 'rxjs/operators';

import { IReleaseNoteResponse, IMonthResponse, ITransferNote, ITransferNoteResponse } from '../models/release-note.model';
import { UserManager } from 'oidc-client';
import { AppConfig } from './app.config';
import { IEmailResponse } from '../models/email.model';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private emailUrl = 'api/email';
  private _userManager: UserManager;
  private recipients: string;

  constructor(private http: HttpClient) {

    const stsSettings = {
      authority: AppConfig.settings.ID4.AuthAddress,
      client_id: AppConfig.settings.ID4.Client,
      redirect_uri: AppConfig.settings.ID4.Redirect,
      scope: 'openid RNapi',
      response_type: 'code',
      post_logout_redirect_uri: AppConfig.settings.ID4.Post_Logout,
      loadUserInfo: false
    };

    this._userManager = new UserManager(stsSettings);

  }

  noCacheHeader = {'Cache-Control': 'no-cache', Pragma: 'no-cache'};

  sendEmail(emailForm): Observable<IEmailResponse> {
    return from(this._userManager.getUser().then(user => {
      if (!(user == null) && !user.expired) {
        const head = new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.access_token}`
        });
        this.recipients = emailForm.To.toString();
        emailForm.To = this.recipients.split(';');
        return this.http.post<any>(this.emailUrl, emailForm, { headers: head }).toPromise();
      } else {
        this._userManager.signinRedirect();
      }
    }));
  }

  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

}
